import styles from './SquareGrid.module.css';
import toSentenceCase from '../utilities/sentenceCase';
import Mark from '../assets/Mark.jsx';
import ArrowDown from '../assets/ArrowDown.jsx';
import { useState, useContext } from 'react';
import { useParams } from "react-router-dom";
import { SmootherContext } from '../components/common/SmootherContext.js';

export default function SquareGrid({title, items}) {

    const smoother = useContext(SmootherContext);

    const { lang } = useParams();

    const [visibleItems, setVisibleItems] = useState(8);
    const itemsPerPage = 8;

    const handleSeeMore = () => {
        setVisibleItems(prev => prev + itemsPerPage);
        smoother.refresh();
    };

    if (!items) return;

    // Get only the visible items
    const displayedItems = items.slice(0, visibleItems);

    // Check if there are more items to show
    const hasMoreItems = visibleItems < items.length;

    return (
        <div className={styles.squareGrid}>
            {title && (
                <h2 className={styles.title}>{title}</h2>
            )}
            
            <div className={styles.grid}>

                {displayedItems.map((item, i) => {

                    return (

                        <div className={styles.cell} key={i}>
                            {item.fields.gridImage && (
                                <img
                                    src={`https:${item.fields.gridImage.fields.file.url}`}
                                    alt={item.fields.title}
                                    width={item.fields.gridImage.fields.file.details.image.width}
                                    height={item.fields.gridImage.fields.file.details.image.height}
                                    className="absolute-cover"
                                />
                            )}
                            <div className={styles.info}>
                                <h3>{toSentenceCase(item.fields.title)}</h3>
                            </div>
                            <div className={styles.mark}>
                                <Mark />
                            </div>
                        </div>

                    )

                })}
                
            </div>

            {hasMoreItems && (
                <button className={`see_more ${styles.square_more_wrap}`} onClick={handleSeeMore}>
                    {lang === "ko" ? "모두 보기" : "SEE MORE"} <ArrowDown />
                </button>
            )}

        </div>
    )
}